export default "__VITE_ASSET__Cqu146Iz__"